import { documentationRootGuid } from '@constants'
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material'
import { Form } from '@ui/forms'
import SubmitButton from '@ui/forms/SubmitButton'
import { useUploadProjectDocumentationFile } from '@editorHooks'
import FormFields from './components/FormFields'

interface Props {
  open: boolean
  onClose: () => void
  parentGuid: string
  onUploadDocument?: (documentId: string) => void
}

const UploadDocumentModal = ({ open, onClose, parentGuid, onUploadDocument }: Props) => {
  const { mutate, isLoading } = useUploadProjectDocumentationFile(documentationRootGuid, data =>
    onUploadDocument?.(data.guid),
  )

  const defaultValues: Omit<FileItem, 'guid'> = {
    name: '',
    hierarchy_position: 0,
    parent_guid: parentGuid,
    type: 'file',
  }

  return (
    <Dialog open={open} onClose={onClose}>
      <Form
        key={JSON.stringify(defaultValues)}
        onSubmit={data => mutate(data)}
        defaultValues={defaultValues}
        id="add-document-form"
      >
        <DialogTitle>Dokument hochladen</DialogTitle>
        <DialogContent style={{ minWidth: 400 }}>
          <FormFields />
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Schließen</Button>
          <SubmitButton
            form="add-document-form"
            loading={isLoading}
            text="Hochladen"
            fullWidth={false}
            disableIfNotDirty={false}
          />
        </DialogActions>
      </Form>
    </Dialog>
  )
}

export default UploadDocumentModal
